import inspectionItems from './inspectionItems';
import activityProcessingDays from "./activityProcessingDays";
import checklists from "./checklists";
import testItems from "./testItems";


const settingService = [
    {
        matcher: 'setting/inspectionItems',
        reply: config => {
            return [200, inspectionItems];
        }
    }, {
        matcher: 'setting/activityProcessingDays',
        reply: config => {
            return [200, activityProcessingDays]
        }
    },{
        matcher: 'setting/checklists',
        reply: config => {
            return [200, checklists]
        }
    },{
        matcher: /setting\/checklists\/(.*)/,
        reply: config => {
            const uuid = /setting\/checklists\/(.*)/.exec(config.url)[1];
            const checklist = checklists.find(checklist => checklist.uuid === uuid);
            return [200, checklist];
        }
    },
    {
        matcher: 'setting/testItems',
        reply: config => {
            return [200, testItems];
        }
    }
]

export default settingService;
